import { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import React from 'react';


export default function Mine() {

    
    return (
        <Button variant="outlined"> X </Button>
    );
}

